import { useMemo } from 'react'

import { Flex } from 'antd'
import { Tooltip } from 'govwell-ui'
import { CodeBookItemFragment } from 'types/graphql'

import { FormSelectLoadingPlaceholder } from 'src/components/form/shared/LoadingPlaceholder'
import Text, { TextSize } from 'src/components/Typography/Text'
import { useCodeBooksQuery } from 'src/fetch/codeBooks'

type Props = {
  codeBookItemIds: number[]
  size?: TextSize
}
const CodeBookItemFieldDisplay = ({ codeBookItemIds, size }: Props) => {
  const { data: codeBooksQuery, isLoading: isLoadingCodeBooks } = useCodeBooksQuery()
  const codeBookItemsById = useMemo(
    () =>
      new Map<number, CodeBookItemFragment>(
        codeBooksQuery?.codeBooks.flatMap((cb) => cb.items).map((cbi) => [cbi.id, cbi])
      ),
    [codeBooksQuery?.codeBooks]
  )

  if (isLoadingCodeBooks) {
    return <FormSelectLoadingPlaceholder />
  }
  return (
    <Flex vertical>
      {codeBookItemIds.map((id) => (
        <Tooltip content={codeBookItemsById.get(id)?.text} key={id}>
          <Text size={size}>{codeBookItemsById.get(id)?.formattedName}</Text>
        </Tooltip>
      ))}
    </Flex>
  )
}

export default React.memo(CodeBookItemFieldDisplay)
